
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AboutHeader from "@/components/about/AboutHeader";
import CharacterProfiles from "@/components/about/CharacterProfiles";
import MissionStatement from "@/components/about/MissionStatement";
import BehindTheScenes from "@/components/about/BehindTheScenes";
import CreatorsTeam from "@/components/about/CreatorsTeam";
import AboutCTA from "@/components/about/AboutCTA";

const About = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-sky-blue/20 via-white to-bobo-green/20">
        <AboutHeader />
        <CharacterProfiles />
        <MissionStatement />
        <BehindTheScenes />
        <CreatorsTeam />
        <AboutCTA />
      </div>
      <Footer />
    </>
  );
};

export default About;
